<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ven-atendimento") {
            next({ name: "ven-atendimento-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ven-atendimento") {
            this.$router.push({ name: "ven-atendimento-list" });
        }
    },
};
</script>